import i18n, { Resource } from "i18next"
import { initReactI18next } from "react-i18next";

import en from "lib/assets/translations/en.json";
import sw from "lib/assets/translations/sw.json";

export enum Languages {
  En = "en",
  Sw = "sw",
}

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources: Resource = {
  en: {
    translation: en,
  },
  sw: {
    translation: sw,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: Languages.En,
    lng: Languages.Sw, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;